document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Drawers (cart / search / mobile menu) ---------------- */
  var overlay = document.querySelector('[data-drawer-overlay]');

  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.hidden = false;
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    document.querySelectorAll('.cart-drawer, .search-drawer, .mobile-menu').forEach(function (el) {
      el.hidden = true;
    });
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(btn.getAttribute('data-drawer-open'));
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawers);
  });
  if (overlay) overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });

  /* ---------------- Flash sale countdown ---------------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var endStr = el.getAttribute('data-countdown');
    var end = new Date(endStr).getTime();
    if (isNaN(end)) return;

    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minutesEl = el.querySelector('[data-cd-minutes]');
    var secondsEl = el.querySelector('[data-cd-seconds]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var now = new Date().getTime();
      var diff = end - now;
      if (diff <= 0) {
        daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
        clearInterval(timer);
        return;
      }
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------------- Hero slider ---------------- */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var track = slider.querySelector('.hero-slider__track');
    var slides = slider.querySelectorAll('.hero-slide');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var index = 0;
    var total = slides.length;
    if (total === 0) return;

    function goTo(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    slider.querySelector('[data-hero-next]').addEventListener('click', function () { goTo(index + 1); });
    slider.querySelector('[data-hero-prev]').addEventListener('click', function () { goTo(index - 1); });
    dots.forEach(function (dot, di) {
      dot.addEventListener('click', function () { goTo(di); });
    });

    var autoplay = setInterval(function () { goTo(index + 1); }, 5500);
    slider.addEventListener('mouseenter', function () { clearInterval(autoplay); });
  });

  /* ---------------- Product / carousel horizontal scroll ---------------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.product-carousel__track');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;
    function scrollAmount() {
      var item = track.querySelector('.product-carousel__item');
      return item ? item.offsetWidth + 20 : 300;
    }
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
  });

  /* ---------------- Product gallery thumbnails ---------------- */
  document.querySelectorAll('[data-product-gallery-main]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = parseInt(thumb.getAttribute('data-gallery-thumb'), 10);
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------------- Product page quantity ---------------- */
  var qtyInput = document.getElementById('ProductQty');
  if (qtyInput) {
    var decrease = document.querySelector('[data-qty-decrease]');
    var increase = document.querySelector('[data-qty-increase]');
    if (decrease) decrease.addEventListener('click', function () {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
    });
    if (increase) increase.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
    });
  }

  /* ---------------- Option swatches (basic variant picking) ---------------- */
  document.querySelectorAll('.option-swatches').forEach(function (group) {
    group.querySelectorAll('.option-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.option-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      });
    });
  });

  /* ---------------- Add to cart (AJAX) ---------------- */
  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('cart-drawer');
        var currentDrawer = document.getElementById('cart-drawer');
        if (newDrawer && currentDrawer) {
          var wasHidden = currentDrawer.hidden;
          currentDrawer.innerHTML = newDrawer.innerHTML;
          currentDrawer.hidden = wasHidden;
        }
      })
      .catch(function () {});

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  document.body.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    var quantity = 1;
    var qtyEl = document.getElementById('ProductQty');
    if (qtyEl) quantity = parseInt(qtyEl.value || '1', 10);

    if (!variantId) {
      var hidden = document.getElementById('ProductVariantId');
      if (hidden) variantId = hidden.value;
    }
    if (!variantId) return;

    var originalText = btn.innerHTML;
    btn.innerHTML = 'Aggiunta in corso…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        refreshCartDrawer();
        openDrawer('cart-drawer');
      })
      .catch(function () {})
      .finally(function () {
        btn.innerHTML = originalText;
        btn.disabled = false;
      });
  });

  /* ---------------- Cart drawer qty +/- and remove ---------------- */
  document.body.addEventListener('click', function (e) {
    var incr = e.target.closest('[data-cart-qty-increase]');
    var decr = e.target.closest('[data-cart-qty-decrease]');
    var remove = e.target.closest('[data-cart-remove]');
    if (!incr && !decr && !remove) return;

    var line = (incr || decr || remove).getAttribute('data-line');
    var body = { line: parseInt(line, 10) };

    if (remove) {
      body.quantity = 0;
    } else {
      var valueEl = (incr || decr).closest('.cart-drawer__item').querySelector('[data-cart-qty-value]');
      var current = parseInt(valueEl.textContent, 10);
      body.quantity = incr ? current + 1 : Math.max(0, current - 1);
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function () { refreshCartDrawer(); })
      .catch(function () {});
  });

  /* ---------------- Buy now ---------------- */
  var buyNow = document.querySelector('[data-buy-now]');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      var hidden = document.getElementById('ProductVariantId');
      var qtyEl = document.getElementById('ProductQty');
      if (!hidden) return;
      var quantity = qtyEl ? parseInt(qtyEl.value || '1', 10) : 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: hidden.value, quantity: quantity })
      }).then(function () { window.location.href = '/checkout'; });
    });
  }
});
